import type { ErrorObject } from '@vuelidate/core';
import type { PassengerKey, Passenger } from '@aviata/booking-data';

import { amplitudeEventsLib, googleAnalyticsEventsLib } from '@/shared/lib';
import type { amplitudeEventsConfigTypes } from '@/shared/config';

export type SavedPaxListOpenParams = {
  key: PassengerKey;
};

export const savedPaxListOpen = (params: SavedPaxListOpenParams) => {
  amplitudeEventsLib.savedPaxListOpen(params);
};

export const selectSavedPassenger = (providerClass?: string) => {
  amplitudeEventsLib.selectSavedPassenger(providerClass);
};

export type PassengersDataSubmitProps = {
  hasSpecialSymbolsInInitials?: boolean;
  validationErrors?: ErrorObject[];
  source?: amplitudeEventsConfigTypes.DetailsPageOpenSource;
  providerClass?: string;
};

export const trySubmitPassengersData = (props: PassengersDataSubmitProps) => {
  if (!props.validationErrors) {
    googleAnalyticsEventsLib.submitPassengersData();
  }
  amplitudeEventsLib.trySubmitPassengersData(props);
};

export type SavedPaxEditClickParams = {
  passenger: Passenger;
  index: number;
  providerClass?: string;
};

export const savedPaxEditClick = (params: SavedPaxEditClickParams) => {
  amplitudeEventsLib.savedPaxEditClick(params);
};

export type SavedPaxSaveClickParams = {
  has_error: boolean;
  firstName?: string;
  lastName?: string;
  providerClass?: string;
};

export const savedPaxSaveClick = (params: SavedPaxSaveClickParams) => {
  amplitudeEventsLib.savedPaxSaveClick(params);
};

export const addNewPaxClick = (providerClass?: string) => {
  amplitudeEventsLib.addNewPaxClick(providerClass);
};

export const openPassengersDataPage = () => {
  googleAnalyticsEventsLib.openPassengersDataPage();
};
